import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ToastMessage } from 'shared/components/simple-toast-group';
import { selectLatestThreeToastMessagesByConversationId } from 'common/store/genesys-cloud/conversations/common/selectors';
import { closeConversationToastMessage } from 'common/store/genesys-cloud/conversations/common/actions';
import { ConversationToastMessage } from 'common/store/genesys-cloud/conversations/common/models';

@Component({
  selector: 'app-genesys-chat-toast-messages',
  templateUrl: './genesys-chat-toast-messages.component.html',
  styleUrls: ['./genesys-chat-toast-messages.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatToastMessagesComponent implements OnInit {
  messages$: Observable<ToastMessage[]>;

  @Input()
  conversationId: string;

  constructor(private readonly store: Store) {
  }

  ngOnInit(): void {
    this.messages$ = this.store.select(selectLatestThreeToastMessagesByConversationId(this.conversationId));
  }

  onMessageDismiss({ id, conversationId }: ConversationToastMessage): void {
    this.store.dispatch(closeConversationToastMessage({ toastMessageId: id, conversationId }));
  }
}
